import React from "react";

const DATE_OPTIONS = {
  year: "numeric",
  month: "long",
  day: "numeric"
};

const Time = ({ timestamp }) => (
  <time className="time">
    {new Date(timestamp).toLocaleDateString("en-US", DATE_OPTIONS)}
  </time>
);

export default Time;
